import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { RootComponent } from '../../services/root-component';
import { Props } from './types';
import css from './style.module.css';
import { SafeAreaView } from '../safe-area-view';

export const Layout = forwardRef<HTMLDivElement, Props>(function Component(
  {
    children,
    shouldStretched = false,
    innerRef,
    innerClassName,
    withSafeArea = true,
    ...props
  },
  forwardedRef
) {
  const Inner = withSafeArea ? SafeAreaView : 'div';

  return (
    <RootComponent
      {...props}
      baseClassName={clsx(css.root, shouldStretched && css.stretched)}
      ref={forwardedRef}
    >
      <Inner className={clsx(css.inner, innerClassName)} ref={innerRef}>
        {children}
      </Inner>
    </RootComponent>
  );
});
